import Button from '@/ui/components/shared/Button';
import React from 'react';
import formatPunctuation from '@/ui/utils/formatPunctuation';
import { Option } from '@/ui/components/shared/multistepFormComponents/types';
import QRCodeTip from '../QRCodeTip';

export type ICInitialScreenProps = {
  mainText: string;
  subtext?: string;
  button?: Option;
  image?: string;
  onSelect: (value: any) => void;
};

function ICInitialScreen({ mainText, subtext, button, image, onSelect }: ICInitialScreenProps) {
  return (
    <div className="flex flex-col items-center text-center ">
      <h1 className="mb-4 text-3xl font-semibold lg:text-4xl">{formatPunctuation(mainText)}</h1>

      <p className="mb-8 max-w-3xl text-center text-md">{subtext}</p>

      <div>
        {image && (
          <div className="overflow-hidden rounded-lg rounded-b-none border border-neutral-100 lg:hidden">
            <img src={image} alt={mainText} />
          </div>
        )}

        <div className="flex w-full flex-col rounded-b-lg lg:w-auto">
          {button && (
            <>
              <Button
                type="button"
                variant="yellowBlackBorder"
                className="rounded-t-none border-t-0 px-6 py-3 lg:hidden"
                onClick={() => onSelect(button.value)}
              >
                {button.text}
              </Button>
              <Button
                type="button"
                className="hidden px-6 py-3 lg:block"
                onClick={() => onSelect(button.value)}
              >
                {button.text}
              </Button>
            </>
          )}
        </div>
      </div>

      <QRCodeTip className="hidden lg:flex" />
    </div>
  );
}

export default ICInitialScreen;
